import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import deleteAccessTokenAndUserData from "@/api/deleteAccessTokenAndUserData";
import { needsOnboarding } from "@/helpers/features";

export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    if (context.auth) {
      if (needsOnboarding(context.auth) && location.pathname !== "/onboarding") {
        throw redirect({ to: "/onboarding" });
      }

      return;
    }

    context.auth = null;
    context.queryClient.removeQueries();
    deleteAccessTokenAndUserData();

    throw redirect({
      to: "/login",
      search: {
        redirect: location.href,
      },
    });
  },
  component: () => <Outlet />,
});
